import reducer from './reducers/index';
import routes from '../routes'
import * as trainingCategoryActions from './actions';
import * as trainingCategoryOperations from './operations';
import * as trainingCategorySelectors from './selectors';

export {
    trainingCategoryOperations,
    trainingCategorySelectors,
    trainingCategoryActions,
};

export default {
    reducer,
    routes
};
